module.exports = __webpack_public_path__ + "img/IMG_0746.07d1dbe7.jpeg";